import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@icon/epic.svg'
import _imports_1 from '@icon/arrow-to.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ba44c43a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label-pic is-pink-epic" }
const _hoisted_2 = { class: "notification__item-converted-to-epic__item-title" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    class: "notification__item-converted-to-epic"
  }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Item converted to Epic ")
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        weight: "500",
        className: "notification__item-converted-to-epic__epic-info"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, " Item " + _toDisplayString(_ctx.notification.itemSequenceNumber), 1),
          _createVNode(_component_icon, {
            data: _imports_1,
            fill: true,
            width: "24px",
            height: "24px",
            color: "#616161"
          }),
          _createElementVNode("a", {
            class: "link is-large",
            target: "_blank",
            href: _ctx.notification.epicUrl
          }, " Epic " + _toDisplayString(_ctx.notification.epicSequenceNumber), 9, _hoisted_3)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}